module.exports = __webpack_public_path__ + "img/recurring-charges-circle.6e10d9d4.svg";